// extracted by mini-css-extract-plugin
module.exports = {"form":"Forms_form__eA5b3","formheading":"Forms_formheading__8o3ZY","formfield":"Forms_formfield__3Df-K","submit":"Forms_submit__2R1oW"};